export default "__VITE_ASSET___iXBZupV__"